import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <section className="privacyPage">
      <div className="privacyPage-container">
        <h1 className="privacyPage-title">Privacy Policy</h1>

        <p className="privacyPage-text">
          At Jaltaara Resort, we respect your privacy and are committed to
          protecting your personal information. This Privacy Policy explains how
          we collect, store, and use your data.
        </p>

        <h3 className="privacyPage-heading">1. Information We Collect</h3>
        <p className="privacyPage-text">
          We may collect your name, phone number, email address, and booking
          details when you fill forms or interact with our website.
        </p>

        <h3 className="privacyPage-heading">2. How We Use Your Information</h3>
        <p className="privacyPage-text">
          Your data is used only for booking confirmations, customer
          communication, and providing better hospitality services.
        </p>

        <h3 className="privacyPage-heading">3. Data Protection</h3>
        <p className="privacyPage-text">
          We use secure systems to protect your personal data and do not share
          it with third parties without consent.
        </p>

        <h3 className="privacyPage-heading">4. Cookies</h3>
        <p className="privacyPage-text">
          Our website may use cookies to enhance user experience and improve
          performance.
        </p>

        <h3 className="privacyPage-heading">5. Contact Us</h3>
        <p className="privacyPage-text">
          For any privacy-related queries, contact us at:
          info@jaltaararesort.com
        </p>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
